import api from './utils/axios';

const pathPrefix = '/agentos/';

const MemoryService = {
  getMyMemories: async (params?: Record<string, any>) => {
    const response = await api.get(`${pathPrefix}my-memories/`, { params });
    return response.data;
  },
  deleteMyMemory: async (id: number) => {
    const response = await api.delete(`${pathPrefix}my-memories/${id}/`);
    return response.data;
  },
};

export default MemoryService;
